import { __rest } from 'tslib';
import React from 'react';
import { styled } from '@teko/ui';
import { space } from 'styled-system';

const Wrapper = styled.div(space, (props) => `
  display: flex;
  ${props.justifyContent ? `justify-content: ${props.justifyContent};` : ''}
  ${props.alignItems ? `align-items: ${props.alignItems};` : ''}
  ${props.flexDirection ? `flex-direction: ${props.flexDirection};` : ''}
`);
const Flex = (_a) => {
    var { children, onClick } = _a, props = __rest(_a, ["children", "onClick"]);
    return (React.createElement(Wrapper, Object.assign({ onClick: () => {
            if (onClick)
                onClick();
        } }, props), children));
};

export { Flex };
